<template>
    <pop-form v-if="state" width="600px">
        <div slot="title">
            批量设置
            <i class="el-icon-close fr" @click="$emit('stateChange', false)"></i>
        </div>
        <div class="editBody">
            <div class="text-tips">已选择{{idList.length}}个{{editType}}</div>
            <el-form ref="form" label-width="100px">
                <el-form-item :label="vip.vip_name" v-for="vip in vipList">
                    <div class="input-grey-append">
                        <el-input placeholder="" v-model="vip.discount">
                            <template slot="append">折</template>
                        </el-input>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div slot="foot" class="foot-box">
            <el-button size="medium" @click="cancelSave">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="medium" type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
        </div>
    </pop-form>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    export default {
        name: "EditManyDiscount",
        components: {PopForm},
        props: {
            state: {
                type: Boolean,
                default: true
            },
            disType: {
                type: String,
                default: "",       //2分类，3单个项目
            },
            idList: {
                type: Array,
                default: [],
            },
            proType: {
                type: Number,
                default: 0        //1项目，2商品
            }
        },
        model: {
            prop: "state",
            event: "stateChange"
        },
        data: () => ({
            formData: {},
            listData: [],
            editType: "",
            vipList: [],
        }),
        mounted: function () {
            this.setEditType();
        },
        methods: {
            submitSave: function () {
                let setData = [];
                this.vipList.forEach( v => {
                    if(obj.isEmpty(v.discount))
                        setData.push({
                            vip_id: v.vip_id,
                            mode: 1,
                            value: 0
                        });
                    else
                        setData.push({
                            vip_id: v.vip_id,
                            mode: 1,
                            value: v.discount
                        });
                });
                let postData = {
                    pro_type: this.proType,
                    dis_type: this.disType,
                    dis_id: this.idList.join(","),
                    dis_data: JSON.stringify(setData),
                };
                obj.postData("store_vip/set_many_discount_data", postData, res => {
                    if(res.errcode === 0)
                        obj.message.success("修改完成");
                    else
                        obj.message.error(res.errdesc);

                    this.$emit("done");
                    this.$emit("stateChange", false);
                });
            },
            cancelSave: function () {
                this.$emit("stateChange", false);
            },
            setEditType: function () {
                if(this.disType == 2){
                    this.editType = "分类";
                }else if(this.disType == 3){
                    this.editType = "项目";
                }
            },
            loadVipList: function () {
                obj.postData("store_vip/get_vip_sort_list", {}, res => {
                    if(res.errcode === 0)
                        this.vipList = res.data;
                });
            }
        },
        watch: {
            state: function (val) {
                if(val)
                    this.loadVipList();
            },
            disType: function (data) {
                this.setEditType();
            }
        }
    }
</script>

<style scoped>
    .text-tips{
        padding: 10px 10px;
    }
    .editBody{
        padding: 0px 30px;
    }
</style>
